import { _t } from '@/locale';
import { GiftCardType } from '../types/types';

const baseTranslation = 'features.giftcard-self-serve.helpers.translations';

export const giftCardTitle = (type: GiftCardType, expiryDateTime: string, hasReturned?: boolean) => {
  const expiryDate = new Date(expiryDateTime);
  const currentDate = new Date();

  if (hasReturned) {
    return _t(`${baseTranslation}.returnedTitle`, { type: giftcardTypeLabel(type) });
  }

  if (expiryDate < currentDate) {
    return _t(`${baseTranslation}.expiredTitle`, { type: giftcardTypeLabel(type) });
  }
  switch (type) {
    case 'value':
      return _t(`${baseTranslation}.valueTitle`);
    case 'wellness':
      return _t(`${baseTranslation}.wellnessTitle`);
    default:
      return _t(`${baseTranslation}.giftcardTitle`);
  }
};

export const giftcardTypeLabel = (type: GiftCardType) => {
  switch (type) {
    case 'value':
      return _t(`${baseTranslation}.label.valuecard`);
    case 'wellness':
      return _t(`${baseTranslation}.label.wellnesscard`);
    default:
      return _t(`${baseTranslation}.label.giftcard`);
  }
};

export const giftcardTypeDefiniteLabel = (type: GiftCardType) => {
  switch (type) {
    case 'value':
      return _t(`valuecardLabel`);
    case 'wellness':
      return _t(`wellnessCardsLabel`);
    default:
      return _t(`giftcardLabel`);
  }
};

export const getGiftCardButtonText = (type: GiftCardType) => _t(`${baseTranslation}.book.${type}`);
